import React from 'react';
import GieTextField from '../../components/GIETextField/GieTextField';
import {ValidatorForm} from 'react-material-ui-form-validator';
import {FormValidator} from '../../util/form-validator'
import GIEButton from '../../components/GIEButton/GieButton';
import GIECheckBox from '../../components/GIECheckBox/GieCheckBox';
import GIELink from "../../components/GIELink/GIELink";

export default class BankFormDetail extends React.Component<any, any> {
  formValidator: FormValidator = new FormValidator();

  constructor(props: any) {
    super(props);
    this.state = {
      isValid: true,
      formControls: {
        iban: {
          value: '',
          error: false,
          errorMessage: ''
        },
        bic: {
          value: '',
          error: false,
          errorMessage: ''
        },
        confidentiality: {
          value: false,
          error: false,
          errorMessage: ''
        }
      }
    }
  }

  checkValidForm = () => {
    let formControls = this.state.formControls;
    let isError = false;
    Object.keys(formControls).forEach(name => {
      const error = this.formValidator.returnError(formControls[name].value, name)
      formControls[name].error = error.error;
      formControls[name].errorMessage = error.errorMessage;
      if (error.error === true) {
        isError = true
      }
    });
    this.setState(formControls)
    return isError;
  }

  emitToParent = () => {
    setTimeout(() => {
      if (this.checkValidForm() === false) {
        this.props.emit(this.state.formControls)
      }
    }, 500);
  }

  change = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const error = this.formValidator.returnError(value.split(' ').join(''), name);
    this.setState({
      formControls: {
        ...this.state.formControls,
        [name]: {
          ...this.state.formControls[name],
          value: value.split(' ').join(''),
          error: error.error,
          errorMessage: error.errorMessage
        }
      }
    });
  }

  checkCGV = (event) => {
    let formControls = this.state.formControls;
    formControls.confidentiality.value = !formControls.confidentiality.value
    this.setState({formControls})
  }

  render() {
    return (
      <div>
        <ValidatorForm ref="form"
                       instantValidate
                       onSubmit={ev => console.log(ev)}
                       onError={errors => console.log(errors)}>
          <GieTextField label="Votre IBAN"
                        required
                        onChange={this.change}
                        name="iban"
                        value={this.state.formControls.iban.value}
                        helperText={this.state.formControls.iban.errorMessage}
                        error={this.state.formControls.iban.error}/>
          <GieTextField label="Votre BIC (8 caractères)"
                        required
                        onChange={this.change}
                        name="bic"
                        value={this.state.formControls.bic.value}
                        helperText={this.state.formControls.bic.errorMessage}
                        error={this.state.formControls.bic.error}/>
          <GIECheckBox checked={this.state.formControls.confidentiality.value === true}
                       name="confidentiality"
                       errorText={this.state.formControls.confidentiality.errorMessage}
                       error={this.state.formControls.confidentiality.error}
                       emit={(event) => this.checkCGV(event)}
                       label="En cochant cette case, j’accepte que mes données personnelles soient utilisées par GIE à des fins de traitement de ma demande"/>
          <div className="d-flex justify-content-between align-items-center mt-4">
            <GIELink href="javascript:void(0)" onClick={this.props.previous} arrowBefore>Précédent</GIELink>
            <GIEButton onClick={this.emitToParent} classes={{root: 'blue-btn'}}>Suivant</GIEButton>
            <div></div>
          </div>
        </ValidatorForm>
      </div>
    );
  }
}
